<header class="header">
  <div class="container">
    <div class="header-wrapper flex-between">
      <img src="/assets/upd-logo.png" class="logo-img" width="276" height="45" alt="SensoCor ML">
      <div class="flex-align-center">
        <app-lang-select></app-lang-select>

        <app-profile-preview></app-profile-preview>
      </div>
    </div>
  </div>
</header>
